import { render, staticRenderFns } from "./request-signature.vue?vue&type=template&id=5d51bc80&"
import script from "./request-signature.vue?vue&type=script&lang=ts&"
export * from "./request-signature.vue?vue&type=script&lang=ts&"
import style0 from "./request-signature.vue?vue&type=style&index=0&id=5d51bc80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports